import actions from "./actions";

const {
  GENERATE_COUPON_BEGIN,
  GENERATE_COUPON_SUCCESS,
  GENERATE_COUPON_ERR,
  GENERATE_COUPON_RESET,

  GET_COUPON_DETAILS_BEGIN,
  GET_COUPON_DETAILS_SUCCESS,
  GET_COUPON_DETAILS_ERR,
  GET_COUPON_DETAILS_RESET,

  OFFER_PRODUCT_LIST_BEGIN,
  OFFER_PRODUCT_LIST_SUCCESS,
  OFFER_PRODUCT_LIST_ERR,
  OFFER_PRODUCT_LIST_RESET,

  COUPON_HISTORY_BEGIN,
  COUPON_HISTORY_SUCCESS,
  COUPON_HISTORY_ERR,
  COUPON_HISTORY_RESET,

  COUPON_DETAILS_BEGIN,
  COUPON_DETAILS_SUCCESS,
  COUPON_DETAILS_ERR,
  COUPON_DETAILS_RESET,
  
} = actions;

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const generateCouponReducer = (state = initialState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case GENERATE_COUPON_BEGIN:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GENERATE_COUPON_SUCCESS:
      return {
        ...state,
        data,
        loading: false,
      };

    case GENERATE_COUPON_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case GENERATE_COUPON_RESET:
      return initialState;

    default:
      return state;
  }
};

export const getRefDetailsReducer = (state = initialState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case GET_COUPON_DETAILS_BEGIN:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_COUPON_DETAILS_SUCCESS:
      return {
        ...state,
        data,
        loading: false,
      };

    case GET_COUPON_DETAILS_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case GET_COUPON_DETAILS_RESET:
      return initialState;

    default:
      return state;
  }
};

export const offerProductListReducer = (state = initialState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case OFFER_PRODUCT_LIST_BEGIN:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case OFFER_PRODUCT_LIST_SUCCESS:
      return {
        ...state,
        data,
        loading: false,
      };

    case OFFER_PRODUCT_LIST_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case OFFER_PRODUCT_LIST_RESET:
      return initialState;

    default:
      return state;
  }
};

export const couponHistoryReducer = (state = initialState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case COUPON_HISTORY_BEGIN:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case COUPON_HISTORY_SUCCESS:
      return {
        ...state,
        data,
        loading: false,
      };

    case COUPON_HISTORY_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case COUPON_HISTORY_RESET:
      return initialState;

    default:
      return state;
  }
};

export const couponDetailsReducer = (state = initialState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case COUPON_DETAILS_BEGIN:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case COUPON_DETAILS_SUCCESS:
      return {
        ...state,
        data,
        loading: false,
      };

    case COUPON_DETAILS_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case COUPON_DETAILS_RESET:
      return initialState;

    default:
      return state;
  }
};
